import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "selection", "open", "onOpenChange", "children", "search", "label", "footer", "virtualized"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneElement, isValidElement, useMemo, useRef } from 'react';
import { MobileModalCustom } from '@sbercloud/uikit-product-mobile-modal';
import { List } from '@snack-uikit/list';
import { useValueControl } from '@snack-uikit/utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function MobileDroplist(_ref) {
  var items = _ref.items,
    selection = _ref.selection,
    openProp = _ref.open,
    onOpenChange = _ref.onOpenChange,
    children = _ref.children,
    search = _ref.search,
    label = _ref.label,
    footer = _ref.footer,
    virtualized = _ref.virtualized,
    rest = _objectWithoutProperties(_ref, _excluded);
  var scrollRef = useRef(null);
  var _useValueControl = useValueControl({
      value: openProp,
      onChange: onOpenChange
    }),
    _useValueControl2 = _slicedToArray(_useValueControl, 2),
    _useValueControl2$ = _useValueControl2[0],
    open = _useValueControl2$ === void 0 ? false : _useValueControl2$,
    setIsOpen = _useValueControl2[1];
  var searchable = search;
  var listJsx = /*#__PURE__*/_jsx("div", {
    className: styles.listWrapper,
    "data-virtualized": virtualized || undefined,
    children: /*#__PURE__*/_jsx(List, _objectSpread({
      items: items,
      selection: selection,
      size: "l",
      search: searchable ? search : undefined,
      scrollRef: searchable || virtualized ? scrollRef : undefined,
      scroll: virtualized,
      virtualized: virtualized
    }, rest))
  });
  var handleClose = function handleClose() {
    return setIsOpen(false);
  };
  var trigger = useMemo(function () {
    var handleOpen = function handleOpen() {
      return setIsOpen(true);
    };
    if (/*#__PURE__*/isValidElement(children)) {
      return /*#__PURE__*/cloneElement(children, {
        // todo: check if there is onClick
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onClick: function onClick(event) {
          var _children$props$onCli, _children$props;
          (_children$props$onCli = (_children$props = children.props).onClick) === null || _children$props$onCli === void 0 ? void 0 : _children$props$onCli.call(_children$props, event);
          handleOpen();
        }
      });
    }
    return /*#__PURE__*/_jsx("span", {
      role: "button",
      tabIndex: 0,
      onClick: handleOpen,
      children: children
    });
  }, [children, setIsOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [trigger, /*#__PURE__*/_jsxs(MobileModalCustom, {
      open: open,
      onClose: handleClose,
      size: searchable || virtualized ? 'full' : 'auto',
      children: [label && /*#__PURE__*/_jsx(MobileModalCustom.Header, {
        title: label
      }), searchable ? listJsx : /*#__PURE__*/_jsx(MobileModalCustom.Body, {
        className: styles.bodyNoPadding,
        content: listJsx
      }), footer && /*#__PURE__*/_jsx(MobileModalCustom.Footer, {
        actions: footer
      })]
    })]
  });
}